(ns frontend.actions.kyc-profile
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))


(defn *->get-screening-statuses
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-profile/get-screening-statuses
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
